import React from 'react';
import PropTypes from 'prop-types';

import './benefit-point.scss';

const BenefitsPoint = ({ imageUrl, description = '', heading = '' }) => {
  return (
    <div className="benefit-point--main-section">
      <div className="benefit-point--image-container">
        <img src={imageUrl} className="benefit-point--img" />
      </div>
      <div className="benefit-point--info-container">
        <span className="benefit-point--heading-text">{heading}</span>
        <span className="benefit-point--decription">{description}</span>
      </div>
    </div>
  );
};

BenefitsPoint.propTypes = {
  heading: PropTypes.string, // Heading text
  description: PropTypes.string, // description text
};

export default BenefitsPoint;
